import {BlinkGlobal} from "../../../blinkpay/UtilsLib";

export function filterStoreByMerchantAndLooseIdArray<T extends { merchantId?: number }>(
    unfilteredObjects: T[],
    looseIdArray: any[],
    looseIdMatches: (obj: T, idOrName: any) => boolean
): T[] {
    const merchantId = BlinkGlobal.iFrameMerchantService?.merchantId;
    if (merchantId) {
        unfilteredObjects = unfilteredObjects.filter(obj => obj.merchantId === merchantId);
    }
    if (looseIdArray) {
        unfilteredObjects = looseIdArray.map(id => unfilteredObjects.find(obj => looseIdMatches(obj, id)))
            .filter(Boolean) as T[];
    }
    return unfilteredObjects;
}
